import homepageHeroCarousel from './../modules/homepage_hero_carousel.js'

export default {
  init() {
    // JavaScript to be fired on the home page

    homepageHeroCarousel();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
